angular.module('impactx.account').filter('ibanToBnkNo', function()
{
    /**
     * Formats a german IBAN to show only the bank number.
     *
     * @param  {string} iban the IBAN to format.
     * @return {string} the formatted IBAN, empty {string} if the IBAN does not have a german country code.
     */
    return function(iban)
    {
        iban = iban || '';
        var formattedIban = '';

        if (iban.length === 22 && iban.startsWith("DE"))
        {
            formattedIban = iban.substr(4, 8);
            formattedIban = formattedIban.replace(/^0*/, "");
        }
        return formattedIban;
    };
});

